export default __webpack_public_path__ + "static/banner-6202735cb6a17f0c0ef90b175d5fbf96.png";